/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        27/02/2020 11:14
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

export default class Weather {

    constructor()
    {
        Weather.initializeWeather();
    }

    static initializeWeather()
    {
        $(".js-trigger-weather-single").click(function () {
        
            $('.js-data').removeClass('open');
        
            $(this).toggleClass("open");
            $(this).parents('.weatherItemRow--preview').next().addClass('open');
        
            $('.js-data.open').slideToggle(500);
        
            return false;
        });
    }
}
